package com.merkost.handpass.admin

import com.merkost.handpass.sharedweb.theme.Accent
import com.merkost.handpass.sharedweb.theme.AccentHover
import com.merkost.handpass.sharedweb.theme.AccentPressed
import com.merkost.handpass.sharedweb.theme.AccentRing
import com.merkost.handpass.sharedweb.theme.AccentSoft
import com.merkost.handpass.sharedweb.theme.Bg
import com.merkost.handpass.sharedweb.theme.Border
import com.merkost.handpass.sharedweb.theme.BorderStrong
import com.merkost.handpass.sharedweb.theme.Danger
import com.merkost.handpass.sharedweb.theme.DangerHover
import com.merkost.handpass.sharedweb.theme.DangerSoft
import com.merkost.handpass.sharedweb.theme.DensityH
import com.merkost.handpass.sharedweb.theme.DensityV
import com.merkost.handpass.sharedweb.theme.GapDefault
import com.merkost.handpass.sharedweb.theme.Info
import com.merkost.handpass.sharedweb.theme.InfoSoft
import com.merkost.handpass.sharedweb.theme.OnAccent
import com.merkost.handpass.sharedweb.theme.OnSurface
import com.merkost.handpass.sharedweb.theme.OnSurfaceFaint
import com.merkost.handpass.sharedweb.theme.OnSurfaceMuted
import com.merkost.handpass.sharedweb.theme.Overlay
import com.merkost.handpass.sharedweb.theme.Pad
import com.merkost.handpass.sharedweb.theme.PadLg
import com.merkost.handpass.sharedweb.theme.RadiusButton
import com.merkost.handpass.sharedweb.theme.RadiusCard
import com.merkost.handpass.sharedweb.theme.RadiusControl
import com.merkost.handpass.sharedweb.theme.RadiusLarge
import com.merkost.handpass.sharedweb.theme.RowHover
import com.merkost.handpass.sharedweb.theme.SkeletonHighlight
import com.merkost.handpass.sharedweb.theme.Success
import com.merkost.handpass.sharedweb.theme.SuccessSoft
import com.merkost.handpass.sharedweb.theme.Surface
import com.merkost.handpass.sharedweb.theme.SurfaceMuted
import com.merkost.handpass.sharedweb.theme.TouchTarget
import com.merkost.handpass.sharedweb.theme.ThumbSize
import com.merkost.handpass.sharedweb.theme.Warning
import com.merkost.handpass.sharedweb.theme.WarningSoft
import com.merkost.handpass.theme.HandpassTokens
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.style.StyleScope
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.cssClass
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.px

private fun StyleScope.adminLightTokens() {
    base {
        Modifier
            .setVariable(Bg, Color("#F7F7F5"))
            .styleModifier {
                property("--hp-shadow-card", "0 4px 18px rgba(0,0,0,.06), 0 1px 3px rgba(0,0,0,.04)")
                property("--hp-shadow-pop", "0 16px 44px rgba(0,0,0,.13)")
                property("--hp-shadow-card-hover", "0 6px 16px rgba(0,0,0,.1)")
                property("--hp-shadow-dropdown", "0 8px 30px rgba(0,0,0,.12)")
                property("--hp-shadow-modal", "0 16px 44px rgba(0,0,0,.13)")
            }
            .setVariable(Surface, Color("#FFFFFF"))
            .setVariable(SurfaceMuted, Color("#F3F3F0"))
            .setVariable(OnSurface, Color("#222220"))
            .setVariable(OnSurfaceMuted, Color("#717169"))
            .setVariable(OnSurfaceFaint, Color("#A2A29A"))
            .setVariable(Border, Color("#ECECE9"))
            .setVariable(BorderStrong, Color("#E0E0DC"))
            .setVariable(RowHover, Color("#FAFAF9"))
            .setVariable(Overlay, Color("rgba(0,0,0,0.5)"))
            .setVariable(SkeletonHighlight, Color("#FFFFFF"))
            .setVariable(Accent, Color(HandpassTokens.Colors.Primary))
            .setVariable(AccentHover, Color(HandpassTokens.Colors.PrimaryDark))
            .setVariable(AccentPressed, Color(HandpassTokens.Colors.PrimaryPressed))
            .setVariable(AccentSoft, Color(HandpassTokens.Colors.PrimarySoft))
            .setVariable(AccentRing, Color("rgba(232,97,42,.28)"))
            .setVariable(OnAccent, Color("#FFFFFF"))
            .setVariable(Success, Color(HandpassTokens.Colors.SuccessGreen))
            .setVariable(SuccessSoft, Color("#E6F4EC"))
            .setVariable(Danger, Color(HandpassTokens.Colors.ErrorRed))
            .setVariable(DangerSoft, Color("#FBE9E9"))
            .setVariable(DangerHover, Color("#C42B2B"))
            .setVariable(Warning, Color("#B7791F"))
            .setVariable(WarningSoft, Color("#FCF3E3"))
            .setVariable(Info, Color(HandpassTokens.Colors.InfoBlue))
            .setVariable(InfoSoft, Color("#EFF6FF"))
            .setVariable(RadiusCard, 18.px)
            .setVariable(RadiusControl, 13.px)
            .setVariable(RadiusButton, 999.px)
            .setVariable(RadiusLarge, 24.px)
            .setVariable(Pad, 22.px)
            .setVariable(PadLg, 28.px)
            .setVariable(GapDefault, 18.px)
            .setVariable(DensityV, 16.px)
            .setVariable(DensityH, 18.px)
            .setVariable(TouchTarget, 44.px)
            .setVariable(ThumbSize, 40.px)
    }
}

private fun StyleScope.adminDarkTokens() {
    base {
        Modifier
            .setVariable(Bg, Color("#131311"))
            .styleModifier {
                property("--hp-shadow-card", "0 4px 18px rgba(0,0,0,.4)")
                property("--hp-shadow-pop", "0 18px 50px rgba(0,0,0,.6)")
                property("--hp-shadow-card-hover", "0 6px 16px rgba(0,0,0,.5)")
                property("--hp-shadow-dropdown", "0 12px 34px rgba(0,0,0,.55)")
                property("--hp-shadow-modal", "0 18px 50px rgba(0,0,0,.6)")
            }
            .setVariable(Surface, Color("#1C1C1A"))
            .setVariable(SurfaceMuted, Color("#262623"))
            .setVariable(OnSurface, Color("#F6F6F3"))
            .setVariable(OnSurfaceMuted, Color("#ADADA6"))
            .setVariable(OnSurfaceFaint, Color("#74746E"))
            .setVariable(Border, Color("#302F2C"))
            .setVariable(BorderStrong, Color("#3D3C38"))
            .setVariable(RowHover, Color("#232321"))
            .setVariable(Overlay, Color("rgba(0,0,0,0.7)"))
            .setVariable(SkeletonHighlight, Color("#34332F"))
            .setVariable(Accent, Color(HandpassTokens.Colors.Primary))
            .setVariable(AccentHover, Color(HandpassTokens.Colors.PrimaryDark))
            .setVariable(AccentPressed, Color(HandpassTokens.Colors.PrimaryPressed))
            .setVariable(AccentSoft, Color("#2A1C14"))
            .setVariable(AccentRing, Color("rgba(232,97,42,.28)"))
            .setVariable(OnAccent, Color("#FFFFFF"))
            .setVariable(Success, Color(HandpassTokens.Colors.SuccessGreen))
            .setVariable(SuccessSoft, Color("#15241C"))
            .setVariable(Danger, Color(HandpassTokens.Colors.ErrorRed))
            .setVariable(DangerSoft, Color("#2A1717"))
            .setVariable(DangerHover, Color("#C42B2B"))
            .setVariable(Warning, Color("#B7791F"))
            .setVariable(WarningSoft, Color("#2A2113"))
            .setVariable(Info, Color(HandpassTokens.Colors.InfoBlue))
            .setVariable(InfoSoft, Color("#1A2536"))
            .setVariable(RadiusCard, 18.px)
            .setVariable(RadiusControl, 13.px)
            .setVariable(RadiusButton, 999.px)
            .setVariable(RadiusLarge, 24.px)
            .setVariable(Pad, 22.px)
            .setVariable(PadLg, 28.px)
            .setVariable(GapDefault, 18.px)
            .setVariable(DensityV, 16.px)
            .setVariable(DensityH, 18.px)
            .setVariable(TouchTarget, 44.px)
            .setVariable(ThumbSize, 40.px)
    }
}

@InitSilk
fun initAdminTokens(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyle(".${ColorMode.LIGHT.cssClass}") { adminLightTokens() }
    ctx.stylesheet.registerStyle(".${ColorMode.DARK.cssClass}") { adminDarkTokens() }
}
